import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { StorefrontService } from './storefront.service';

@Component({
  selector: 'strfrnt-storefront',
  template: `
    <div class="store-container" [class.with-top-bar]="showTopBar$ | async">
      @if (showTopBar$ | async) {
        <strfrnt-store-header [hideSignIn]="hideSignIn$ | async"></strfrnt-store-header>
      }
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
    `,
  styleUrls: ['./storefront.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StorefrontComponent implements OnInit, OnDestroy {
  marketId$: Observable<string>;
  partnerId$: Observable<string>;
  showTopBar$: Observable<boolean>;
  hideSignIn$: Observable<boolean>;

  private unsubscribe$ = new Subject<void>();

  constructor(private storefrontService: StorefrontService) {}

  private initializeObservables(): void {
    this.partnerId$ = this.storefrontService.partnerId$;
    this.marketId$ = this.storefrontService.marketId$;
    this.showTopBar$ = this.storefrontService.showTopBar$;
    this.hideSignIn$ = this.storefrontService.hideSignIn$;
  }

  ngOnInit(): void {
    this.initializeObservables();
    combineLatest([this.partnerId$, this.marketId$])
      .pipe(
        takeUntil(this.unsubscribe$),
        tap(([pid, mid]) => {
          if (!pid) {
            return;
          }

          this.storefrontService.setPartnerLogoImage(pid, mid);
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
